module.exports = __webpack_public_path__ + "static/media/kuul promo.dd3b5327.png";